import React from 'react';
import { Modal, Spin, Tooltip } from 'antd';
import PropTypes from 'prop-types';
import moment from 'moment';
import { DataTable } from '../../../components/dataTable/data-table';
import { useDictionaryTranslation } from '../../../hooks/useDictionaryTranslation';
import { useNotifications } from '../../../hooks/useNotifications';
import { GenericButton } from '../../../components/buttons/table-buttons/TableButtons';
import { useUserSessions } from '../hook/useUserSessions';

const formatDate = (date) => date && moment(date).format('DD MMM YYYY HH:mm:ss');

const ModalUserSessions = ({ userId, show, closeModal }) => {
  const { translate: t } = useDictionaryTranslation();
  const { showConfirmNotification } = useNotifications();
  const { isLoading, tableData, getData, revokeSession } = useUserSessions({ userId });

  const getRevokeAction = (session) => () => {
    showConfirmNotification({
      title: t('areYouSure'),
      content: t('sessionWillBeRevoked'),
      onOk: () => revokeSession(session._id),
    });
  };

  const columns = [
    {
      key: 'createdAt',
      title: t('createdAt'),
      dataIndex: 'createdAt',
      render: formatDate,
    },
    {
      key: 'actions',
      title: t('actions'),
      align: 'center',
      render: (_, record) => (
        <Tooltip title={t('revoke')}>
          <GenericButton type="danger" icon="log-out" onClick={getRevokeAction(record)} />
        </Tooltip>
      ),
    },
  ];

  return (
    <Modal title={t('sessions')} centered destroyOnClose width="50%" onCancel={closeModal} open={show} footer={null}>
      <Spin spinning={isLoading}>
        <DataTable
          rowKey="_id"
          columns={columns}
          onChange={getData}
          isLoading={isLoading}
          tableData={tableData}
          headerData={{
            show: false,
          }}
        />
      </Spin>
    </Modal>
  );
};

ModalUserSessions.propTypes = {
  userId: PropTypes.string,
  show: PropTypes.bool,
  closeModal: PropTypes.func,
};

export default ModalUserSessions;
